<template>
    <div>
        <div class="ex-bg-pink" :class="{'ex-bg-white': isShownLink == false}">
            <div class="tour-num">
                <div class="text-center fs-18">{{$t('tour.search_tour')}}</div>
                <div class="error-message" v-if="errorMessage">
                    <div class="d-flex">
                        <i class="icon-warning mr-2"></i>
                        <div class="errror-txt">
                            <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                            <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                        </div>
                        <a @click="setIsClosed" href="#" style="font-size:12px">締切済ツアーも対象として再検索</a>
                    </div>
                </div>
                <form class="form-search" @submit.stop.prevent="submit" ref="form">
                    <div class="mt-4 input-num d-flex">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="XXXXXX-XXX"
                            v-model="keyword_search"
                            inputmode="decimal"
                            maxlength="10"
                            :disabled="utils.isCooperator()"
                        />
                        <button class="btn btn-circle-50 ml-3" :disabled="utils.isCooperator()">
                            <i class="icon-search"></i>
                        </button>
                    </div>
                </form>

                <div class="d-flex justify-content-center mt-3rem">
                    <button  @click='isShownLink = true; isNoTour = true;' class="btn btn-certi w-200 fs-18" :disabled="utils.isCooperator()">
                        <div>{{$t('button.certi_regis')}}</div>
                        <div class="certi_body">{{$t('button.certi_regis2')}}</div>
                    </button>
                </div>
                <div class="notify-box" v-if="isNotify">
                    <div class="header">
                        <i class="icon-notify"></i>
                        <div class="notify-title">{{$t('notify.title')}}</div>
                    </div>
                    <div class="body">
                        <div class="title">
                            {{ infos.title }}
                        </div>
                        <div v-html="infos.body"></div>
                    </div>
                </div>
                <div class="notify-box" v-else>
                    <div class="no-show-header">
                        <i class="icon-notify-no-show"></i>
                        <div class="notify-title">{{$t('notify.title')}}</div>
                    </div>
                    <div class="no-show-body">
                        {{$t('notify.no-show')}}
                    </div>
                </div>
                <div class="login-info-box fs-16" v-if="user">
                    <div class="login-info pb-2">
                        <div class="row no-gutters mt-2">
                            <div class="col-5 pl-3 fs-15">{{$t('login_info.last_login_date')}}</div>
                            <div class="col-7 pl-1 fs-15">{{user.last_login}}</div>
                        </div>
                        <div class="row no-gutters mt-2">
                            <div class="col-5 pl-3 fs-15">{{$t('login_info.last_update_pass_date')}}</div>
                            <div class="col-7 pl-1 fs-15">{{user.last_update_pass_time}}</div>
                        </div>
                    </div>
                </div>

                <div class="mt-3 text-center" style="font-size:14px">
                    操作方法などわからないことあれば<br>
                    <a :href="$t('chatbot.url')" target="_blank">証憑類電子化チャットボット</a>へ
                </div>
            </div>

            <div v-if="isShownLink" class="box-bottom-pink">
                <div class="btns-box">
                    <ul class="lst-btns">
                        <li>
                            <a @click="toVoucherByGroup(groupVoucherType.invoice_bill)" class="btn btn-white-38 ex-has-icon">
                                {{$t('voucher.group.invoice_bill')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                        <li>
                            <a @click="goSelectContract()" class="btn btn-white-38 ex-has-icon">
                                {{$t('voucher.group.contract')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                        <li>
                            <a @click="toVoucherByGroup(groupVoucherType.local_expense_voucher)" class="btn btn-white-38 ex-has-icon">
                                {{$t('voucher.group.local_expense_voucher')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                        <li>
                            <a @click="toVoucherByGroup(groupVoucherType.other)" class="btn btn-white-38 ex-has-icon">
                                {{$t('voucher.group.other')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import StorageService from "@/services/common/storage.service";
import TourManagementService from '@/services/module/tour.service';
import InfoService from '@/services/admin/infos.service';
import { AuthService } from "@/services/common/auth.service";
import Utils from "@/helpers/utils";
import { Constants } from "@/helpers/constants";
export default {
    name: 'SPTourInput',
    data () {
        const storageUser = JSON.parse(StorageService.getUser());
        let user = null;
        if (storageUser) {
            const last_login = storageUser.last_login ? storageUser.last_login.replace(/-/g, '/') : '';
            const last_update_pass_time = storageUser.last_update_pass_time ? storageUser.last_update_pass_time.replace(/\./g, '/') : '';
            const userInfo = {
                last_login: last_login,
                last_update_pass_time: last_update_pass_time
            }
            user = userInfo;
        }
        return {
            utils: Utils,
            keyword_search: '',
            groupVoucherType: Constants.GroupVoucherType,
            username: '',
            password: '',
            companyID: 'latest_demo2',
            submitted: false,
            isShownLink: false,
            errorMessage: "",
            user: user,
            isNotify: false,
            infos: {},
            isClosed: 0,
            isNoTour: false,
        };
    },
    computed: {
        ...mapState('account', ['status']),
    },
    watch: {
        keyword_search: function () {
            let pattern = /^\d{7}$/;
            if (pattern.test(this.keyword_search)) {
                let keyword_search_first = this.keyword_search.slice(0,6);
                let hyphen = '-';
                let keyword_search_second = this.keyword_search.slice(6);
                this.keyword_search =  keyword_search_first + hyphen + keyword_search_second
            }
        },
        'infos.body' : function () {
            this.infos.body = (this.infos.body).replace(/\n/g, '<br>');
        }
    },
    created () {
        this.$emit('enableButton', '<i class="icon-logout"></i>');
        this.$emit('update:actionHandler', () => { AuthService.logout(); });
        let tourInfo = JSON.parse(StorageService.getTour());
        if (tourInfo && tourInfo.tour_number) {
            this.keyword_search = tourInfo.tour_number;
        }
    },
    methods: {
        ...mapActions('account', ['login', 'logout']),
        handleSubmit (e) {
            this.submitted = true;
            const { username, password, companyID } = this;
            if (username && password) {
                this.login({ username, password, companyID });
            }
        },
        submit (e = "") {
            if (!this.keyword_search) {
                this.errorMessage = '';
                return;
            }
            let _this = this;
            let patt = /^\d{6}-\d{3}$/;
            if (patt.test(this.keyword_search)) {
                TourManagementService.getTour(_this.keyword_search, _this.isClosed)
                    .then(function (response) {
                        if (response.status != 200) {
                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                _this.errorMessage = _this.$root.$t("error.error_code_" + errorCode);
                                _this.$forceUpdate();
                            }
                        } else {
                            if (!Utils.isEmptyObj(response.data)) {
                                _this.$router.push("/tour/after-input");
                                _this.errorMessage = "";
                            } else {
                                _this.tourInfo = [];
                                // let msg = this.$root.$t("general.no_data");
                                // this.$toasted.success(msg, {});
                            }
                        }
                    });
            } else {
                this.errorMessage = this.$root.$t("error.error_code_13");
            }
        },
        toVoucherByGroup (groupType) {
            // this.$router.push("/voucher/detail-group?groupType=" + groupType);
            StorageService.removeTour();
            this.$router.push("/voucher/list?groupType=" + groupType);
        },
        goSelectContract () {
            if (this.isNoTour) {
                StorageService.removeTour();
            }
            this.$router.push("/voucher/selectContract");
        },
        setIsClosed(e) {
            this.isClosed = 1;
            return this.submit(e);
        }
    },
    mounted () {
        InfoService.getInfo().then(response =>{
            if (response.status == 403) {
                StorageService.saveExpired();
                AuthService.doLogout();
            }
            if (response.status == 200) {
                this.infos = response.data;
                if (this.infos) {
                    this.isNotify = this.infos.is_notify;
                    // this.infos.body = (this.infos.body).replace(/n/g, '<br>');
                } else {
                    this.isNotify = false;
                }
            }
        })
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Tour/Input.vue